/*
 * @Author: ylq
 * @Date: 2022-09-19 15:35:08
 * @Desc: DESC
 * @Last Modified by: ylq
 * @Last Modified time: 2023-04-26 14:27:17
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');

const DASHBOARD = {
  path: '/dashboard',
  name: 'dashboard',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'dashboard-workplace' },
  meta: {
    title: '工作台',
    requiresAuth: true,
    hideChildrenInMenu: true,
    icon: 'icon-dashboard',
    roles: 'workbench',
    order: 0
  },
  children: [
    {
      path: '',
      name: 'dashboard-workplace',
      component: () => import('@/views/dashboard/dashboard.vue'),
      meta: {
        requiresAuth: true,
        title: '工作台',
        roles: 'workbench:workbench'
      }
    }
  ]
};

export default DASHBOARD;
